import { render, staticRenderFns } from "./WorkingGroupEventForm.vue?vue&type=template&id=c9032808"
import script from "./WorkingGroupEventForm.vue?vue&type=script&lang=js"
export * from "./WorkingGroupEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports